<template>
  <IconLucideStarOff />
</template>
